function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = [
    "displayOrder"
];
import * as React from 'react';
import { useGridRootProps } from "../../utils/useGridRootProps.js";
import { useGridPrivateApiContext } from "../../utils/useGridPrivateApiContext.js";
var useGridColumnMenuSlots = function(props) {
    var apiRef = useGridPrivateApiContext();
    var rootProps = useGridRootProps();
    var defaultSlots = props.defaultSlots, defaultSlotProps = props.defaultSlotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, hideMenu = props.hideMenu, colDef = props.colDef, _props_addDividers = props.addDividers, addDividers = _props_addDividers === void 0 ? true : _props_addDividers;
    var processedComponents = React.useMemo(function() {
        return _extends({}, defaultSlots, slots);
    }, [
        defaultSlots,
        slots
    ]);
    var processedSlotProps = React.useMemo(function() {
        if (!slotProps || Object.keys(slotProps).length === 0) {
            return defaultSlotProps;
        }
        var mergedProps = _extends({}, slotProps);
        Object.entries(defaultSlotProps).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], currentSlotProps = _param[1];
            mergedProps[key] = _extends({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    var defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    var userItems = React.useMemo(function() {
        var defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter(function(key) {
            return !defaultComponentKeys.includes(key);
        });
    }, [
        slots,
        defaultSlots
    ]);
    return React.useMemo(function() {
        var uniqueItems = Array.from(new Set(_to_consumable_array(defaultItems).concat(_to_consumable_array(userItems))));
        var cleansedItems = uniqueItems.filter(function(key) {
            return processedComponents[key] != null;
        });
        var sorted = cleansedItems.sort(function(a, b) {
            var leftItemProps = processedSlotProps[a];
            var rightItemProps = processedSlotProps[b];
            var leftDisplayOrder = Number.isFinite(leftItemProps === null || leftItemProps === void 0 ? void 0 : leftItemProps.displayOrder) ? leftItemProps.displayOrder : 100;
            var rightDisplayOrder = Number.isFinite(rightItemProps === null || rightItemProps === void 0 ? void 0 : rightItemProps.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce(function(acc, key, index) {
            var itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            var processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                var customProps = _objectWithoutPropertiesLoose(processedComponentProps, _excluded);
                itemProps = _extends({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? _to_consumable_array(acc).concat([
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    rootProps.slots.baseDivider,
                    {}
                ]
            ]) : _to_consumable_array(acc).concat([
                [
                    processedComponents[key],
                    itemProps
                ]
            ]);
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems,
        rootProps.slots.baseDivider
    ]);
};
export { useGridColumnMenuSlots };
